// extracted by mini-css-extract-plugin
export default {"resumeRoot":"resume-view_resumeRoot__JvqLk","main":"resume-view_main__ftyGX","footer":"resume-view_footer__exo6J","footerLink":"resume-view_footerLink__XM5qg"};